import {Provider} from '@angular/core';
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from '../../../core/shared/test/data/test-harness.types';

import {
    HgGdvPartnerObjectComponent
} from '../component/object-components/hg-gdv-partner-object-component/hg-gdv-partner-object.component';
import {
    HgGdvPartnerFullComponent
} from '../component/object-components/hg-gdv-partner-object-component/view/full/hg-gdv-partner-full.component';
import {
    HgGdvPartnerSideComponent
} from '../component/object-components/hg-gdv-partner-object-component/view/side/hg-gdv-partner-side.component';
import {
    HgTestComponent
} from '../component/object-components/hg-gdv-partner-object-component/view/shared/hg-test-component/hg-test.component';
import {
    HgGdvPartnerBaseComponent
} from '../component/object-components/hg-gdv-partner-object-component/view/hg-gdv-partner-base.component';
import {HgConfigPage} from '../page/overview/hc-config/hg-config.page';
import {ObjectBaseComponent} from '../../../core/shared/object/mvs-object-base/object-base.component';

const hgModuleEntry: TestModuleDefinition = {
    key: 'hg',
    label: 'Partner Object (hg)',
    components: [
        {
            key: 'hgGdvPartnerObjectComponent',
            component: HgGdvPartnerObjectComponent,
            selector: 'hg-gdv-partner-object-base-component',
            type: 'ObjectBaseComponent',
            label: 'GDV Partner Object'
        },
        {
            key: 'hgGdvPartnerFullComponent',
            component: HgGdvPartnerFullComponent,
            selector: 'hg-gdv-partner-full',
            type: 'HgGdvPartnerBaseComponent',
            label: 'GDV Partner Full View'
        },
        {
            key: 'hgGdvPartnerSideComponent',
            component: HgGdvPartnerSideComponent,
            selector: 'hg-gdv-partner-side',
            type: 'HgGdvPartnerBaseComponent',
            label: 'GDV Partner Side View'
        },
        {
            key: 'hgTestComponent',
            component: HgTestComponent,
            selector: 'hg-gdv-test-component',
            type: 'component',
            label: 'Test Component'
        },
        {
            key: 'HgConfigPage',
            component: HgConfigPage,
            selector: 'mvs-hg-config',
            type: 'PageComponent',
            label: 'hg config'
        }
    ]
};

export const HG_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: hgModuleEntry, multi: true }
];
